<template>
    <div> 
        <div class='panBody'>
            <div class='panSelect'>
                <div class='panSelectL'>
                    <span class="label-span">
                    <label class="label">数据日期</label> 
                    <el-date-picker v-model="query.selectDay"  value-format="yyyy-MM-dd" style="width:160px;" type="date"  placeholder="选择日期"></el-date-picker>
                </span> 
                </div>  
            </div> 
            <div class='table1'>
                <el-table :data="tableData1" border row-key="superiorId" size="mini" :highlight-current-row="true">
                    <el-table-column :label="query.selectDay+' 订购量'" align="center">
                    <el-table-column v-for="(item,index) in tableHead1" :key="index" :label="item.label" :prop="item.prop"></el-table-column>
                    </el-table-column>
                </el-table>
                
            </div>
            <div class='table2'>
                 <el-table :data="tableData2" border row-key="superiorId" size="mini" :highlight-current-row="true">
                    <el-table-column :label="query.selectDay+' 转化率'" align="center">
                    <el-table-column v-for="(item,index) in tableHead2" :key="index" :label="item.label" :prop="item.prop"></el-table-column>
                    </el-table-column>
                </el-table>
            </div>
             
        </div>  
         
    </div>  
    
</template>

<script> 
import Schart from 'vue-schart';
import bus from '../../common/bus';
import {fetchData,getMessage} from '../../../api/dashBoard';
import {getPayInfo} from '../../../api/cashApply';  
export default {
    name: 'dashboard',
    data() {
        return {   
            query:{dataType2:'1',selectDay:''},   
            // 表头数据 
            tableHead1:[
                {prop:'nowDay',label:'产品名称'},
                {prop:'num1',label:'福建冠悦乐'},
                {prop:'num2',label:'官洲趣盈'},
                {prop:'num3',label:'流量果'},
                {prop:'num4',label:'山东馨馨'},
                {prop:'num5',label:'深圳秋葵'},
                {prop:'nowCount',label:'¶ 统计'}, 
            ],
            // 表格数据
            tableData1: [
                {nowDay: "河南移动-咪咕足球", num1: "10", num2: "30", num3: "19", num4: "63", num5: "22", nowCount: "1250", selectCount: "8632"},
                {nowDay: "多省移动-椰岛随心游", num1: "21", num2: "29", num3: "366", num4: "796", num5: "10",nowCount: "2100",selectCount: "15063"},
                {nowDay: "¶ 统计", num1: "31", num2: "59", num3: "385", num4: "859", num5: "32",nowCount: "3350",selectCount: "195063"}, 
            ],  
            tableHead2:[
                {prop:'nowDay',label:'产品名称'},
                {prop:'num1',label:'福建冠悦乐'},
                {prop:'num2',label:'官洲趣盈'},
                {prop:'num3',label:'流量果'},
                {prop:'num4',label:'山东馨馨'},
                {prop:'num5',label:'深圳秋葵'},
                {prop:'nowCount',label:'¶ 统计'}, 
            ],
            tableData2: [
                {nowDay: "河南移动-咪咕足球", num1: "13.11%", num2: "1.22%", num3: "16.39", num4: "0.63%", num5: "12.01%", nowCount: "3.38%", selectCount: "10.38%"},
                {nowDay: "多省移动-椰岛随心游", num1: "2.39%", num2: "9.01%", num3: "3.66%", num4: "7.96%", num5: "10.9%",nowCount: "7.38%",selectCount: "6.38%"},
                {nowDay: "¶ 统计", num1: "2.39%", num2: "9.01%", num3: "3.66%", num4: "7.96%", num5: "10.9%",nowCount: "7.38%",selectCount: "6.38%"}, 
            ],
        }
    },
    components: {
        Schart
    },
    mounted() {
        
    }, 
    computed: {
         
    },
    created() { 
        const nowDate = new Date();
        nowDate.setTime(nowDate.getTime() - 3600 * 1000 * 24);
        var date = {
            year: nowDate.getFullYear(),
            month: nowDate.getMonth(),
            day: nowDate.getDate()
        };
        if(date.month==0){
            date.month = 12;
            date.year =  date.year - 1;
        }else{
            date.month = date.month +1;
        }
        const dayDate1 = date.year + "-" + (date.month >= 10 ? date.month : "0" + date.month)+"-" + (date.day >= 10 ? date.day : "0" + date.day) ;  
        this.$set(this.query, "selectDay", dayDate1.toString());   
    },
    methods: {
        initData(){
            
        },
        
    }
};
</script>


<style>  
.panSelect{
    width:99%;
    height: 30px;  
    margin:5px 0 20px 1%; 
    text-align: center;
}
.panSelectL{
    width:40%;
    float:left;
    text-align: left;;
} 
.panSelectC{
    width:20%;
    float:left;
    text-align: center;
} 
.table1,.table2{
    margin: 0 1%;
    width:98%;
}
.table2{
    margin-top:35px;
}

.table1 .cell{
    color:#777;
    font-weight:900 ;
}
.el-table__row .cell{
    font-weight:500 ;
}
 
</style>
 
